<div
  #glPopoutContainer
  ngResizable
  (mousedown)="requestFocus($event)"
  [ng2-draggable]="!disableAllActions"
  [hidden]="!show"
  class="gl-popout gl-popout-{{(embeddedComponentConfig != null) ? embeddedComponentConfig.componentName : 'initializing'}} {{alertStatusClass}} {{nativeDesktop ? 'desktop nativeDesktop' : ''}}"
  [style.left.px]="position.x"
  [style.top.px]="position.y"
  [style.z-index]="position.z"
  [style.width]="position.w > 0 ? (position.w + 'px') : 'auto'"
  [style.height]="position.h > 0 ? (position.h + 'px'): 'auto'"
  [ng2DraggableHandle]="glPopoutHeader"
  [bound]="{ x: 0, y: 50 }"
  [@.disabled]="nativeDesktop"
  [disableResize]="!resizable"
  [directions]="!resizable ? [] : resizableDirections != null ? resizableDirections : ['bottom', 'top', 'left', 'right', 'top-left', 'bottom-left', 'top-right', 'bottom-right']"
  [minWidth]="minWidth"
  [minHeight]="minHeight"
  style="display: flex; flex-direction: column"
>
  <!-- [ngClass]="{'flash': badgeCount > 0}" -->
  <!-- (resizeEnd)="onResize($event)" -->
  <div
    #glPopoutHeader
    class="gl-popout-header"
    [nativeDesktopStyle]="{'-webkit-app-region': 'drag'}"
    [ngClass]="[disableAllActions ? 'unselectable': '', alertStatusClass]"
  >
    <!-- 'flash' : badgeCount > 0 -->
    <button
      type="button"
      (click)="close()"
      [disabled]="disabledClose || disableAllActions"
      class="bfx-glpopout-button icon-close"
      placeholder="Close"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      title="Close"
    ></button>
    <button
      *ngIf="showDock"
      type="button"
      (click)="maximize()"
      [disabled]="disabledDock || disableAllActions"
      class="bfx-glpopout-button"
      [ngClass]="{
        'icon-bfx_pop_out': maximized, 
        'icon-bfx_square' : !maximized
      }"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      [title]="maximized ? 'Restore' : 'Maximize'"
    ></button>
    <button
      *ngIf="showDock"
      type="button"
      (click)="minimize()"
      [disabled]="disabledDock || disableAllActions"
      class="bfx-glpopout-button icon-remove"
      placeholder="Minimize"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      title="Minimize"
    ></button>
    <button
      *ngIf="showDock"
      type="button"
      (click)="dock()"
      [disabled]="disabledDock || disableAllActions"
      class="bfx-glpopout-button icon-bfx_pop_in"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      placeholder="Re-Dock"
      title="Re-Dock"
    ></button>

    <button
      *ngIf="showSetings"
      (click)="showSettings($event)"
      [disabled]="disabledSettings || disableAllActions"
      type="button"
      class="bfx-glpopout-button icon_ion_settings_filled"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      placeholder="Settings"
      title="Settings"
    ></button>
    <button
      *ngIf="showDebug"
      (click)="toggleDebug()"
      [disabled]="disabledDebug || disableAllActions"
      type="button"
      placeholder="Debug"
      title="Debug"
      style="font-size: 13px; line-height: normal"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      class="bfx-glpopout-button"
    >
      <i class="icon-ion_chevron_expand"></i>
    </button>
    <button
      *ngIf="showDevTools"
      (click)="openDevTools()"
      type="button"
      placeholder="Dev Tools"
      title="Dev Tools"
      style="font-size: 13px; line-height: normal"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      class="bfx-glpopout-button"
    >
      <i class="icon-bug_report"></i>
    </button>
    <button
      *ngIf="showRefresh"
      (click)="reload()"
      [disabled]="disabledRefresh || disableAllActions"
      class="bfx-glpopout-button icon-refresh"
      [nativeDesktopStyle]="{'-webkit-app-region': 'no-drag'}"
      aria-hidden="true"
    ></button>
    <!-- customized version of the button needed -->
    <span>
      <span [innerHtml]="frameTagTitle"></span>
      <span class="badge lm_tab_badge" *ngIf="badgeCount > 0">{{badgeCount}}</span>
    </span>
  </div>
  <div class="gl-popout-body">
    <div class="gl-popout-glasspane" *ngIf="disableAllActions"></div>
    <div class="gl-popout-component" [ngClass]="{'blurred': disableAllActions}" #glPopout></div>
  </div>
</div>
